import Icon from '../icon/Icon';

import styles from '../../styles/modules/tasks/Tasks.module.scss';

import { useConfigStore } from '../../store/useConfigStore';

import Modal from '../modal/Modal';

const TaskButton = ({ className = '' }) => {
	const { openModal } = useConfigStore((s) => s);

	const handleClick = () => {
		openModal(Modal);
	};

	return (
		<button type='button' className={className} onClick={handleClick}>
			<span>Перейти к выполнению</span>
			<Icon name='arrow' className={styles['icon-arrow']} />
		</button>
	);
};

export default TaskButton;
